<script lang="ts" setup>
import type { TooltipContentProps, TooltipRootEmits, TooltipRootProps } from 'reka-ui'
import { TooltipArrow, TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<Partial<TooltipRootProps & TooltipContentProps> & { content?: string }>()
const emits = defineEmits<TooltipRootEmits>()

const forward = useForwardPropsEmits(props, emits)
</script>

<template>
  <TooltipProvider>
    <TooltipRoot
      v-bind="forward"
    >
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipContent
        :side="props.side"
        :side-offset="5"
        class="animate-tooltip-in z-10 origin-(--reka-tooltip-content-transform-origin) rounded-xl bg-(--theme-50,var(--color-white)) px-2 py-1 text-lg font-medium text-(--theme-5,var(--color-black))  shadow-xl"
      >
        {{ content }}
        <TooltipArrow
          :height="6"
          :width="12"
          class="fill-(--theme-50,var(--color-white)) stroke-(--theme-50,var(--color-white))"
        />
      </TooltipContent>
    </TooltipRoot>
  </TooltipProvider>
</template>
